import { ClientConfiguration } from 'api/client-domain/client-domain.types';

export enum LoyaltyProvider {
  INCENTIVIO = 'INCENTIVIO',
  SQUARE = 'SQUARE',
}

export enum FeatureFlag {
  IncPayments,
  Workspaces,
  MenuIntelligence,
  SendGrid,
  SMSReports,
  SMSMarketing,
  SMSOrderConfirmation,
  SMSAccountVerification,
  SMSGuestCheckoutVerification,
  SMSPasswordlessAuthentication,
  GuestCheckOut,
  GuestJourney,
}

const featureFlagResolverMap = {
  [FeatureFlag.IncPayments]: (clientConfiguration?: ClientConfiguration) =>
    !!clientConfiguration?.incentivioPayments?.enabled,
  [FeatureFlag.Workspaces]: (clientConfiguration?: ClientConfiguration) =>
    !!clientConfiguration?.workspaces?.enabled,
  [FeatureFlag.MenuIntelligence]: (clientConfiguration?: ClientConfiguration) =>
    !!clientConfiguration?.guestJourney?.enabledMenuIntelligence &&
    !!clientConfiguration?.guestJourney?.enabled,
  [FeatureFlag.SendGrid]: (clientConfiguration?: ClientConfiguration) =>
    clientConfiguration?.emailSetting?.emailHandler === 'SENDGRID',
  [FeatureFlag.SMSReports]: (clientConfiguration?: ClientConfiguration) =>
    clientConfiguration?.sms?.enabledMarketing ||
    clientConfiguration?.sms?.enabledOrdering ||
    clientConfiguration?.sms?.enabledAccountVerification ||
    (clientConfiguration?.guestCheckoutVerification?.enabled === true &&
      clientConfiguration?.guestCheckoutVerification?.deliveryMethod ===
        'SMS') ||
    (clientConfiguration?.passwordlessAuthentication?.enabled === true &&
      !!clientConfiguration?.passwordlessAuthentication?.deliveryMethod?.includes(
        'SMS',
      )),
  [FeatureFlag.SMSMarketing]: (clientConfiguration?: ClientConfiguration) =>
    clientConfiguration?.sms?.enabledMarketing,
  [FeatureFlag.SMSOrderConfirmation]: (
    clientConfiguration?: ClientConfiguration,
  ) => clientConfiguration?.sms?.enabledOrdering,
  [FeatureFlag.SMSAccountVerification]: (
    clientConfiguration?: ClientConfiguration,
  ) => clientConfiguration?.sms?.enabledAccountVerification,
  [FeatureFlag.SMSGuestCheckoutVerification]: (
    clientConfiguration?: ClientConfiguration,
  ) =>
    clientConfiguration?.guestCheckoutVerification?.enabled === true &&
    clientConfiguration?.guestCheckoutVerification?.deliveryMethod === 'SMS',
  // Consistent with SMSGuestCheckoutVerification: the SMS-report tab shows only
  // when passwordless auth is enabled AND SMS is a delivery method. Note the
  // passwordless `deliveryMethod` is an array (unlike guest-checkout's string).
  // Backed by the client-config work in PR #742 (sc-364390).
  [FeatureFlag.SMSPasswordlessAuthentication]: (
    clientConfiguration?: ClientConfiguration,
  ) =>
    clientConfiguration?.passwordlessAuthentication?.enabled === true &&
    !!clientConfiguration?.passwordlessAuthentication?.deliveryMethod?.includes(
      'SMS',
    ),
  [FeatureFlag.GuestCheckOut]: (clientConfiguration?: ClientConfiguration) =>
    !!clientConfiguration?.guestCheckOutEnabled,
  [FeatureFlag.GuestJourney]: (clientConfiguration?: ClientConfiguration) =>
    !!clientConfiguration?.guestJourney?.enabled,
};

export const isFeatureFlagEnabled = (
  featureFlag: FeatureFlag,
  clientConfiguration?: ClientConfiguration,
) =>
  !!clientConfiguration
    ? featureFlagResolverMap[featureFlag](clientConfiguration)
    : false;
